import type { PcmpMoInfo } from '../types/pcmpMoReport.types';

/** "Name (HR id)": how the pickers label a person. */
export function pcmpMoLabel(mo: Pick<PcmpMoInfo, 'name' | 'hrId'>): string {
  return mo.hrId ? `${mo.name} (${mo.hrId})` : mo.name;
}

/**
 * The reporting manager the Many MOs report names in its scope label
 * ("All - Reporting: Name (HR id) | Division: ..."), when one was picked.
 */
export function pcmpReportingLabelFromScope(scopeLabel: string): string | undefined {
  return /Reporting: ([^|]+?)\s*(?:\||$)/.exec(scopeLabel)?.[1];
}
